// extracted by mini-css-extract-plugin
module.exports = {"message":"style_message__XjFL7","reloadButtonArea":"style_reloadButtonArea__3kHIY"};